// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.btn-primary {
  background: #0B2D71;
  color: #fff;
  border: none;
  border-radius: 0;
  font-family: "GothamBold", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";
  font-size: 0.88em;
  cursor: pointer;
}

.btn-primary:hover {
  background: #0066B2;
}`, "",{"version":3,"sources":["webpack://./src/components/return-to-delta-report-btn/return.to.delta.report.btn.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,yBAAA;EACA,gBAAA;AACJ;;AACE;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EAEA,+EAAA;EACA,iBAAA;EACA,eAAA;AACJ;;AAGE;EACE,mBAAA;AAAJ","sourcesContent":[".btn-container {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 20px;\n  }\n  .btn-primary {\n    background: #0B2D71 ;\n    color: #fff;\n    border: none;\n    border-radius: 0;\n   \n    font-family: 'GothamBold', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif';\n    font-size: 0.88em;\n    cursor: pointer;\n   // transition: background 0.3s, transform 0.3s;\n  }\n  \n  .btn-primary:hover {\n    background: #0066B2;\n   // transform: translateY(-2px); /* Lift effect on hover */\n  }\n\n  // .btn-primary:active {\n  //   box-shadow: 0 2px #0056b3, 0 0 15px 3px rgba(0, 123, 255, 0.7);\n  // }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
